import { ApiConfiguration, ApiService } from "webshop-modules";
import { PiniaPluginContext } from 'pinia';

declare module 'pinia' {
    export interface PiniaCustomProperties {
        $apiService: ApiService;
    }
}

export function ApiServicePlugin(apiConfiguration: ApiConfiguration) {
    return (context: PiniaPluginContext): void => {
        const { store } = context;
        store.$apiService = new ApiService(apiConfiguration);
    };
}